import type { ValueOf } from "ts-essentials";

export const ControlsPage = {
  General: "general",
  Segmentations: "segmentations",
} as const;
export type ControlsPage = ValueOf<typeof ControlsPage>;
